module.exports = __webpack_public_path__ + "images/icons/flags/IT-7947ad70.svg";